<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Wymogi IDD'" [name]="'Zaświadczenia'"></app-breadcrumb>
<div class="idd-training-certificate-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
    <mat-form-field class="idd-training-certificate-list-filter">
      <mat-label>Rok</mat-label>
      <input type="number" matInput placeholder="2021" name="year" [(ngModel)]="initialFilters.year">
    </mat-form-field>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="idd-training-certificate-list-filter idd-training-certificate-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-partners
      [multiple]="false" label="Partner"
      class="idd-training-certificate-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-regionals
      [multiple]="false" label="Regionalny (majątek) OFWCA"
      class="idd-training-certificate-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict
      [multiple]="false" [dictType]="'idd_training_status'"
      [label]="'Status'" class="idd-training-certificate-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'meeting_leader'"
      [label]="'Organizator'" class="idd-training-certificate-list-filter"
      [(ngModel)]="initialFilters.meetingLeader" name="meetingLeader"
    ></app-dict>

    <app-dict-insurance-companies
      [multiple]="false" label="TU" class="idd-training-certificate-list-filter"
      [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany"
    ></app-dict-insurance-companies>

    <app-datepicker
      class="idd-training-certificate-list-filter"
      label="Data szkolenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$realisedAt" name="gte$realisedAt"
    ></app-datepicker>

    <app-datepicker
      class="idd-training-certificate-list-filter"
      label="Data szkolenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$realisedAt" name="lte$realisedAt"
    ></app-datepicker>

    <mat-form-field class="idd-training-certificate-list-filter">
      <mat-label>Numery RAU</mat-label>
      <input matInput placeholder="Wymień po przecinku" name="rauNumber" [(ngModel)]="initialFilters.rauNumber">
    </mat-form-field>

    <mat-form-field
      class="idd-training-certificate-list-filter">
      <mat-label>Użytkownik</mat-label>
    <mat-select [(ngModel)]="initialFilters.createdBy" name="createdBy">
      <mat-option value="">Wszyscy</mat-option>
      <mat-option value="1bd65d85-0fb2-4ef8-8743-261bb3b8ea4f"> Mariusz Jurczak</mat-option>
      <mat-option value="23eac9f7-8029-4823-81e7-229b4a361faf"> Dominika Ryczkowska</mat-option>
      <mat-option value="a92926d4-3a69-48c1-86a1-61def0811c4d"> Marta Gajowa</mat-option>
      <mat-option value="dc1ad512-9339-4eb6-8a1a-9e8b36cf4fc7">Martyna Grzymała</mat-option>
    </mat-select>
    </mat-form-field>


    <mat-form-field appearance="standard" class="idd-training-certificate-list-filter">
      <mat-label>AML</mat-label>
      <mat-select [(ngModel)]="initialFilters.aml" name="aml">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-datepicker
      class="idd-training-certificate-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="idd-training-certificate-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

  </form>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>
    <div>
      <button (click)="generateCertificates()" [disabled]="!(userPermissions | async).idd_training.read_report"
              mat-raised-button color="accent"><mat-icon>download</mat-icon> <span> Pobierz zaświadczenia</span></button>
    </div>
    <div>
      <button *ngIf="(userPermissions | async).idd_training.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).idd_training.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    </div>
    <div>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    </div>
    <div>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="iddTrainingCertificates" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="iddTraining">
      <th mat-header-cell *matHeaderCellDef> Szkolenie IDD </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/szkolenia-idd/szczegoly', element.iddTraining.uuid]">IDD {{element.iddTraining.year}} {{element.iddTraining.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="rau">
      <th mat-header-cell *matHeaderCellDef> RAU </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let rau of element.iddTraining.ofwca.rauNumbers">
          {{rau.rau}} <br>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.iddTraining.ofwca?.partner" class="default-link" [routerLink]="['/partnerzy/szczegoly', element.iddTraining.ofwca?.partner?.uuid]">{{element.iddTraining.ofwca?.partner?.shortName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwcaAssetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA </th>
      <td mat-cell *matCellDef="let element">
        {{element.iddTraining.ofwca.assetsRegional?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerAssetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) Partnera </th>
      <td mat-cell *matCellDef="let element">
        {{element.iddTraining.ofwca?.partner?.assetsRegionalFullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="meetingLeader">
      <th mat-header-cell *matHeaderCellDef> Organizator </th>
      <td mat-cell *matCellDef="let element">
        {{element.meetingLeader?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="logo">
      <th mat-header-cell *matHeaderCellDef [width]="'150px'"> Logo </th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        <img *ngIf="element.insuranceCompany?.imageLocation" src="/rest/crm/insuranceCompany/{{element.insuranceCompany?.id}}/image" alt="Zdjęcie" height="30"/>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.insuranceCompany">
          <a class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{element.insuranceCompany.name}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="realisedHours">
      <th mat-header-cell *matHeaderCellDef> Zrealizowano </th>
      <td mat-cell *matCellDef="let element">
        Majątek: {{(floor(element.realisedAssetsMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.realisedAssetsMinutes % 60).toString() | number:'1.0-0') + 'min'}}<br>
        Życie: {{(floor(element.realisedLifeMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.realisedLifeMinutes % 60).toString() | number:'1.0-0') + 'min'}}<br>
        Ogólne: {{(floor(element.realisedGeneralMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.realisedGeneralMinutes % 60).toString() | number:'1.0-0') + 'min'}}<br>
      </td>
    </ng-container>

    <ng-container matColumnDef="realisedAt">
      <th mat-header-cell mat-sort-header="realisedAt" *matHeaderCellDef> Data szkolenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.realisedAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell mat-sort-header="createdAt" *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.username}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button (click)="certificateOverview(element)"
                mat-icon-button color="primary"><mat-icon>visibility</mat-icon></button>
        <button (click)="downloadCertificate(element)"
                [disabled]="!(userPermissions | async).idd_training.write"
                mat-icon-button color="accent"><mat-icon>download</mat-icon></button>

        <button (click)="deleteCertificate(element)"
                [disabled]="!(userPermissions | async).idd_training.delete"
                mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="aml">
      <th mat-header-cell *matHeaderCellDef> AML </th>
      <td mat-cell *matCellDef="let element">
        {{!element.aml ? 'Nie' : 'Tak'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
